export const BTN_PRIMARY =
  "inline-flex items-center justify-center gap-2 bg-[#0A1F3C] text-white border border-[#D4AF37] hover:bg-[#D4AF37] hover:text-[#050505] transition-colors duration-300 px-8 py-3 uppercase tracking-widest text-sm font-semibold";

export const BTN_PLATINUM =
  "inline-flex items-center justify-center gap-2 bg-[#E5E4E2] text-[#050505] hover:bg-white transition-colors duration-300 px-8 py-3 uppercase tracking-widest text-sm font-semibold";

export const BTN_GOLD =
  "inline-flex items-center justify-center gap-2 bg-[#D4AF37] text-[#050505] border border-[#D4AF37] hover:bg-[#C9A227] transition-colors duration-300 px-8 py-3 uppercase tracking-widest text-sm font-semibold";

export const INPUT_CLS =
  "bg-transparent border-b border-[#C9C9C4] focus:border-[#D4AF37] text-[#0A1F3C] py-3 px-2 w-full outline-none transition-colors duration-300 placeholder:text-gray-400 rounded-none";

export const INPUT_ON_NAVY =
  "bg-transparent border-b border-white/30 focus:border-[#D4AF37] text-white py-3 px-2 w-full outline-none transition-colors duration-300 placeholder:text-blue-200/50 rounded-none";

export const SECTION = "py-24 md:py-32 px-6 md:px-12 lg:px-24";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
